import styled from 'styled-components';
import filterIcon from '@/assets/icons/filter.png';
import {
  WelcomeTitle as BaseWelcomeTitle,
  LoginForm as BaseLoginForm,
  PhoneInputContainer as BasePhoneInputContainer,
  VerificationContainer as BaseVerificationContainer,
  AgreementText as BaseAgreementText,
} from '@/pages/login/styles';

export const LoginModalContainer = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
  width: 532px;
  height: 402px;
  background: #121212;
  border-radius: 12px;
  padding: 45px 42px;
  box-sizing: border-box;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.45);
  font-size: 18px;
  line-height: 1;
  padding: 4px;

  &:hover {
    color: rgba(255, 255, 255, 0.75);
  }
`;
interface ModalTitleProps {
  $isNewUser?: boolean;
  isWelcome?: boolean;
}

export const ModalTitle = styled(BaseWelcomeTitle).withConfig({shouldForwardProp: (prop) => !['isWelcome', 'isNewUser'].includes(prop)})<ModalTitleProps>`
  font-size: 28px;
  font-family: 'PingFang SC';
  margin-bottom: 24px;
  position: relative;
  && {
    ${(props) => (props.$isNewUser || props.isWelcome === false) && `
      width: 100% !important;
      color: rgb(255, 109, 73);

       &::before {
         content: '';
        display: inline-block;
        width: 74px;
        height: 74px;
        top: -15px;
        left: 38px;
        position: absolute;
        z-index:-1;
        // background: url(${filterIcon}) no-repeat;
        background: transparent;
      }
    `}
  }
  &::before {
    content: '';
    display: inline-block;
    width: 74px;
    height: 74px;
    top: -15px;
    left: 152px;
    position: absolute;
    z-index:-1;
    background: url(${filterIcon}) no-repeat;
  }
`;


export const ModalLoginForm = styled(BaseLoginForm)`
  .ant-form-item:nth-child(1) {
    margin-bottom: 17px !important;
  }
  .ant-form-item:nth-child(2) {
    margin-bottom: 24px !important;
  }
  .ant-btn {
    border-radius: 12px;
  }
  .ant-btn-primary:not(.ant-btn-block) {
    background: transparent !important;
    background-color: transparent !important;
    color: #ff6d49 !important;
    box-shadow: none !important;

    &:not(:disabled):hover {
      background: transparent !important;
      background-color: transparent !important;
      color: #ff6d49 !important;
    }
  }
  .countdown:disabled {
    color: #fff !important;
    opacity: 0.4;
  }
`;

export const ModalPhoneInputContainer = styled(BasePhoneInputContainer)`
  border-color: #464646;
`;

export const ModalVerificationContainer = styled(BaseVerificationContainer)`
  border-color: #464646;
`;

export const ModalAgreementText = styled(BaseAgreementText)`
  display: block;
  text-align: center;
  margin-bottom: 24px !important;
`;
